export default "__VITE_ASSET__OKt87jOy__"